define([
	"csi/def/ActionFactory",
	"./_CustomViewAction"
], function(ActionFactory,_CustomViewAction) {

	return ActionFactory.declare("CustomViewReset", _CustomViewAction, {
		classController: "csi/view/customview/ResetController",
		customViewDirty: true
	});
});